module.exports = __webpack_public_path__ + "img/arrowDown.3d594bae.svg";